import type { ReapproCategoryPreviewResponse } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

/**
 * Rend la réponse complète : `products` ET `cappingIndisponible` (#720), ce dernier
 * signalant que la preview a rendu des besoins bruts faute de run persisté pour la date.
 */
export const fetchReapproCategoryPreview = async (
  storeId: number,
  categoryId: number,
  deliveryDate?: string,
): Promise<ReapproCategoryPreviewResponse> => {
  const response = await gozokiApiWithAuth.get<ReapproCategoryPreviewResponse>(
    `/stores/${storeId}/reappro-categories/${categoryId}/preview`,
    { params: deliveryDate ? { deliveryDate } : undefined },
  )
  return response.data
}
